document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-vw-drawer]');
  if (!drawer) return;

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  const panel = drawer.querySelector('.vw-drawer__panel');
  const closeButton = drawer.querySelector('.vw-drawer__close');
  let lastTrigger = null;

  function setExpanded(value) {
    document.querySelectorAll('[data-vw-drawer-open]').forEach((button) => {
      button.setAttribute('aria-expanded', String(value));
    });
  }

  function openDrawer(trigger = null) {
    lastTrigger = trigger || document.activeElement;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('vw-drawer-lock');

    setExpanded(true);

    if (closeButton) {
      closeButton.focus();
    }
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('vw-drawer-lock');

    setExpanded(false);

    drawer.querySelectorAll('details[open]').forEach((detail) => {
      detail.removeAttribute('open');
    });

    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
    }
  }

  document.querySelectorAll('[data-vw-drawer-open]').forEach((button) => {
    button.setAttribute('type', 'button');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', 'vw-drawer-panel');
  });

  if (panel) {
    panel.id = 'vw-drawer-panel';
  }

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const openTrigger = target.closest('[data-vw-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(openTrigger);
      return;
    }

    const closeTrigger = target.closest('[data-vw-drawer-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (!drawer.classList.contains('is-open')) return;

    const clickedInsidePanel = target.closest('.vw-drawer__panel');

    if (!clickedInsidePanel) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });
});